import { createContext } from 'react';

import { IaInfoFormLayout } from '../IAInfoForm/IaInfoFormLayout';
import { IdentifierTypes } from 'components/base/IdentifierSelector';

export const IAScanDocumentContext = createContext<{
  documentType: IdentifierTypes,
   infoFormlayout: IaInfoFormLayout }>(
     { documentType: IdentifierTypes.IDENTIFIER, infoFormlayout: 'client' },
   );
